<template>
  <div class="">
    <div class="">
      <InputText
        v-model="filter.search"
        textFloat=""
        placeholder="Search Name"
        type="text"
        name="search_customer"
        faIcon="search"
        :disabled="isBusy"
        className="  overflow-auto w-50 my-2"
        @onEnter="handleSearch"
        @onClickIcon="handleSearch"
      />
      <b-table
        responsive
        striped
        hover
        :fields="fields"
        :items="items"
        :busy="isBusy"
        show-empty
        empty-text="No matching records found"
        class="table-main"
      >
        <template v-slot:cell(action)="{ item }">
          <font-awesome-icon
            @click="selectProduct(item)"
            :icon="['fas', 'search']"
            class="pointer fa-search text-gray"
            id="search-icon"
          />
        </template>
        <template v-slot:cell(created_time)="data">
          <div>
            {{ new Date(data.item.created_time) | moment($formatDateNew) }}
          </div>
          <div class="time-color">
            {{ new Date(data.item.created_time) | moment($formatTimeNew) }}
          </div>
        </template>
        <template v-slot:cell(description)="{ item }">
          {{ item.description || "-" }}
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTake"
        :pageOptions="pageOptions"
        :filter="filter"
        :rows="rows"
        @pagination="pagination"
      />
      <div v-if="collectionName" class="mt-3 f-weigth-bold">
        Product in {{ collectionName }} Collection
      </div>

      <b-table
        responsive
        striped
        hover
        :fields="subFields"
        :items="subItem"
        :busy="isSubBusy"
        show-empty
        empty-text="No matching records found"
        class="table-main mt-3"
        :sort-by.sync="subFilter.sortBy"
        :sort-desc.sync="subFilter.sortDesc"
        no-local-sorting
        @sort-changed="storeSorting"
      >
        <template v-slot:cell(price)="{ item }">
          {{ item.price | numeral("0,0.00") }}
        </template>
        <template v-slot:cell(name)="{ item }">
          <div
            class="text-link"
            @click="$router.push(`/product/detail/${item.id}`)"
          >
            {{ item.name }}
          </div>
          <span class="text-gray">{{ item.barcode }}</span>
        </template>
        <template v-slot:table-busy>
          <div class="text-center text-black my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-2">Loading...</strong>
          </div>
        </template>
      </b-table>
      <Pagination
        @handleChangeTake="handleChangeTakeSubItem"
        :pageOptions="pageOptions"
        :filter="subFilter"
        :rows="subRows"
        @pagination="paginationSubItem"
      />
    </div>
  </div>
</template>
<script>
import OtherLoading from "@/components/loading/OtherLoading";
import { mapGetters } from "vuex";
export default {
  components: {
    OtherLoading,
  },
  computed: {
    ...mapGetters({
      branchId: "getBranchId",
    }),
  },
  name: "Product",
  data() {
    return {
      tebIndex: 0,
      isLoading: false,
      filter: {
        search: "",
        page: 1,
        take: 10,
        product_id: this.$route.params.id,
      },
      id: this.$route.params.id,
      items: [],
      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 5, text: "5 / page" },
        { value: 10, text: "10 / page" },
        { value: 30, text: "30 / page" },
        { value: 50, text: "50 / page" },
        { value: 100, text: "100 / page" },
      ],
      fields: [
        {
          key: "collection_code",
          label: "Code",

          thClass: "w-1",
        },

        {
          key: "name",
          label: "Name",
          thClass: "w-1",
        },
        {
          key: "total_product",
          label: "Total Product",

          thClass: "w-1",
        },
        {
          key: "description",
          label: "Description",

          thClass: "w-1",
        },
        {
          key: "created_time",
          label: "Created Time",

          thClass: "w-1",
        },
        {
          key: "action",
          label: "Action",
          thClass: "w-1",
        },
      ],
      isFetch: false,
      subItem: [],
      subFields: [
        {
          key: "name",
          label: "Name / Code / Type ",
          thClass: "w-1",
          tdClass: "text-left",
        },

        {
          key: "barcode",
          label: "Barcode",
          thClass: "w-1",
          sortable: true,
        },
        {
          key: "price",
          label: "ราคา",
          thClass: "w-1",
        },
        {
          key: "stock",
          label: "จำนวน",
          thClass: "w-1",
        },
      ],
      subFilter: {
        search: "",
        page: 1,
        take: 10,
        collection_id: null,
        branch_id: null,
        sortBy: "",
        sortDesc: false,
        SortColumnId: 0,
        SortType: true,
      },
      collectionName: "",
      isSubBusy: false,
      subRows: 0,
      is_serial: false,
    };
  },
  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      if (this.isFetch) {
        return;
      }
      this.isBusy = true;

      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_collection_by_product_id/${this.id}`,
        this.filter
      );
      if (res.result == 1) {
        this.isFetch = true;

        this.items = res.detail.data;

        this.rows = res.detail.count;
      }

      this.isBusy = false;
    },
    async handleSearch() {
      this.filter.page = 1;
      this.isFetch = false;
      await this.getList();
    },
    pagination(page) {
      this.filter.page = page;
      this.isFetch = false;
      this.getList();
    },
    handleChangeTake(value) {
      this.subFilter.page = 1;
      this.subFilter.take = value;

      this.getList();
    },
    async paginationSubItem(page) {
      this.subFilter.page = page;

      await this.getSubItemCollection();
    },
    async handleChangeTakeSubItem(value) {
      this.subFilter.page = 1;
      this.subFilter.take = value;
      await this.getSubItemCollection();
    },
    async selectProduct(item) {
      this.subFilter.collection_id = item.id;
      this.subFilter.branch_id = this.branchId;
      this.collectionName = item.name;
      await this.getSubItemCollection();
    },

    async getSubItemCollection() {
      this.isSubBusy = true;
      const res = await this.axios.post(
        `${this.$baseUrl}/product/get_product_by_collection`,
        this.subFilter
      );

      this.subItem = res.detail.product;
      this.subRows = res.detail.count;

      this.isSubBusy = false;
    },

    async storeSorting(ctx) {
      const sameColumn = this.subFilter.sortBy === ctx.sortBy;
      const sameDirection = this.subFilter.sortDesc === ctx.sortDesc;

      if (sameColumn && !ctx.sortDesc) {
        this.subFilter.sortBy = "";
        this.subFilter.sortDesc = false;
        this.subFilter.SortColumnId = 0;
        this.subFilter.SortType = true;
      } else {
        this.subFilter.sortBy = ctx.sortBy;
        this.subFilter.sortDesc = ctx.sortDesc;

        const sortColumnMap = {
          barcode: 1,
        };

        this.subFilter.SortColumnId = sortColumnMap[ctx.sortBy] || 0;
        this.subFilter.SortType = ctx.sortDesc;
        await this.getSubItemCollection();
      }
    },
  },
};
</script>
